<template>
    <div class="flex justify-center lg:justify-between">
        <div class="hidden lg:block">
            <a
                v-if="previousActive"
                href="#"
                @click.prevent="changePage($event, curPage - 1)"
                aria-label="Previous"
                :class="previousClasses"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="13"
                    viewBox="0 0 39 13"
                    fill="none"
                >
                    <path
                        d="M6.69922 1.6998L1.65922 6.58233L6.69922 11.4648"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2.61892 6.56003L36.459 6.56006"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </a>
            <span v-else :class="previousClasses" aria-label="Previous">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="13"
                    viewBox="0 0 39 13"
                    fill="none"
                >
                    <path
                        d="M6.69922 1.6998L1.65922 6.58233L6.69922 11.4648"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2.61892 6.56003L36.459 6.56006"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </span>
        </div>
        <ul class="flex flex-wrap gap-2">
            <li v-show="shownPages[0] !== 1">
                <a
                    href="#"
                    @click.prevent="changePage($event, 1)"
                    class="bb flex h-[30px] min-w-[30px] rounded-sm items-center justify-center text-sm tracking-wide text-xp-carbon font-normal hover:bg-xp-electron-green hover:text-black"
                >
                    1
                </a>
            </li>
            <li v-if="shownPages[0] > 2">
                <a
                    href="#"
                    @click.prevent="changePage($event, 2)"
                    class="bb flex h-[30px] min-w-[30px] rounded-sm items-center justify-center text-sm tracking-wide text-xp-carbon font-normal hover:bg-xp-electron-green hover:text-black"
                >
                    2
                </a>
            </li>
            <li v-if="showBeforeEllipsis" class="disabled">
                <span class="px-2">...</span>
            </li>
            <li v-for="(page, index) in shownPages" :key="index">
                <a
                    href="#"
                    v-if="!isCurrent(page)"
                    @click.prevent="changePage($event, page)"
                    class="flex h-[30px] min-w-[30px] rounded-sm items-center justify-center text-sm tracking-wide text-xp-carbon font-normal hover:bg-xp-electron-green hover:text-black"
                >
                    {{ page }}
                </a>
                <span
                    v-else
                    class="flex h-[30px] min-w-[30px] rounded-sm items-center justify-center bg-xp-electron-green text-sm font-black tracking-wide text-black"
                    >{{ page }}</span
                >
            </li>
            <li v-if="showAfterEllipsis" class="disabled">
                <span class="px-2">...</span>
            </li>
            <li v-if="showAfterEllipsis">
                <a
                    href="#"
                    @click.prevent="changePage($event, pageCount - 1)"
                    class="bb flex h-[30px] min-w-[30px] rounded-sm items-center justify-center text-sm tracking-wide text-xp-carbon font-normal hover:bg-xp-electron-green hover:text-black"
                >
                    {{ pageCount - 1 }}
                </a>
            </li>
            <li v-if="showAfterEllipsis">
                <a
                    href="#"
                    @click.prevent="changePage($event, pageCount)"
                    class="bb flex h-[30px] min-w-[30px] rounded-sm items-center justify-center text-sm tracking-wide text-xp-carbon font-normal hover:bg-xp-electron-green hover:text-black"
                >
                    {{ pageCount }}
                </a>
            </li>
        </ul>
        <div class="hidden lg:block">
            <a
                v-if="nextActive"
                href="#"
                @click.prevent="changePage($event, curPage + 1)"
                aria-label="Next"
                :class="nextClasses"
            >
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="13"
                    viewBox="0 0 39 13"
                    fill="none"
                >
                    <path
                        d="M31.3398 11.3002L36.3798 6.41767L31.3398 1.53516"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M35.4201 6.43997L1.58008 6.43994"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </a>
            <span v-else :class="nextClasses" aria-label="Next">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="13"
                    viewBox="0 0 39 13"
                    fill="none"
                >
                    <path
                        d="M31.3398 11.3002L36.3798 6.41767L31.3398 1.53516"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M35.4201 6.43997L1.58008 6.43994"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-miterlimit="20"
                        stroke-linecap="square"
                    />
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        pageCount: {
            type: Number,
            required: true,
        },
        curPage: {
            type: Number,
            required: true,
        },
        showLimit: {
            type: Number,
            default: 7,
            //must be odd otherwise the pagination will look janky
            validator: (showLimit) => showLimit % 2,
        },
    },
    data: () => ({}),
    methods: {
        isCurrentClasses(page) {
            return {
                current: this.isCurrent(page),
            };
        },
        isCurrent(page) {
            return page === this.curPage;
        },
        changePage(e, page) {
            //blur the link so that its focus styling isn't being applied
            e.target.blur();
            this.$emit("change-page", page);
        },
    },
    computed: {
        nextClasses() {
            return {
                'disabled text-xp-medium-grey pointer-events-none py-2': !this.nextActive,
                'text-black hover:text-xp-electron-green py-2': this.nextActive,
            };
        },
        previousClasses() {
            return {
                'disabled text-xp-medium-grey pointer-events-none py-2': !this.previousActive,
                'text-black hover:text-xp-electron-green py-2': this.previousActive,
            };
        },
        previousActive() {
            //only active previous button if the current page isn't 1
            return this.curPage !== 1;
        },
        nextActive() {
            //only active next button if the current page isn't the total page count (last page)
            return this.curPage !== this.pageCount;
        },
        showBeforeEllipsis() {
            //show ellipsis if the last shown page is less than the page count minus two
            return this.shownPages[0] > 3;
        },
        showAfterEllipsis() {
            //show ellipsis if the last shown page is less than the page count minus two
            return (
                this.shownPages[this.shownPages.length - 1] < this.pageCount - 2
            );
        },
        pagesPerSide() {
            return (this.showLimit - 1) / 2;
        },
        shownPages() {
            let start,
                rtn = [],
                end_bounds = this.pageCount - this.showLimit,
                start_bounds = this.showLimit,
                limit = this.showLimit;

            //adjust starting number and limit based on where you are within the page bounds
            if (this.curPage < start_bounds) {
                start = 1;
            } else if (this.curPage > end_bounds) {
                start = end_bounds;
                limit++;
            } else {
                start = this.curPage - this.pagesPerSide;
            }

            // //iterate through pages, starting at the start variable and until the page display limit is met
            for (let i = start; i < start + limit && i <= this.pageCount; i++) {
                //only push a value if its greater than 0
                !(i < 1) && rtn.push(i);
            }

            return rtn;
        },
    },
};
</script>
